import { styled } from 'styled-components';

const H1 = styled.h1``;

export { H1 };
